import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CopyrightIcon from '@mui/icons-material/Copyright';

function AppointmentIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new customer
    const [Name, setName] = useState('');
    const [AddressLine1, setAddressLine1] = useState('');
    const [AddressLine2, setAddressLine2] = useState('');
    const [ContactNumber1, setContactNumber1] = useState('');
    const [ContactNumber2, setContactNumber2] = useState('');
    const [Email, setEmail] = useState('');

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [fromDate, setFromDate] = useState(getCurrentDate());
    const [toDate, setToDate] = useState(getCurrentDate());
    const [companyDetails, setCompanyDetails] = useState(null);

    // Fetch company details
    const fetchCompanyDetails = async () => {
        try {
            const response = await fetchData('BranchApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setCompanyDetails(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching company details:', error);
        }
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
        fetchPaymentModes();
        fetchCompanyDetails();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout, fromDate, toDate]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) => {
        // Search filter
        const matchesSearch = Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Date filter
        let matchesDate = true;
        if (fromDate || toDate) {
            const appointmentDate = new Date(item.AppointmentDate);
            if (fromDate) {
                const from = new Date(fromDate);
                from.setHours(0, 0, 0, 0);
                matchesDate = matchesDate && appointmentDate >= from;
            }
            if (toDate) {
                const to = new Date(toDate);
                to.setHours(23, 59, 59, 999);
                matchesDate = matchesDate && appointmentDate <= to;
            }
        }

        return matchesSearch && matchesDate;
    });


    const [formData, setFormData] = useState([]);

    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)//, token
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                    //setTimeout(() => calculateProgress(), 200);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);

    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        let endpoint = `/${companyId}`;
        if (fromDate && toDate) {
            endpoint = `/${companyId}/${fromDate}/${toDate}`;
        }

        fetchData('AppointmentApi', endpoint, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Appointment Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDelete = async () => {
        deleteData('AppointmentApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('AppointmentApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    // Appointment Creation Modal
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const [patients, setPatients] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
    const [patientSearchQuery, setPatientSearchQuery] = useState('');
    const [appointmentForm, setAppointmentForm] = useState({
        patientId: '',
        patientName: '',
        patientMRD: '',
        patientPhone: '',
        doctorId: '',
        appointmentDate: getCurrentDate(),
        appointmentTime: getCurrentTime(),
        consultationamount: '',
        paymentModeId: '',
        remark: '',
        IsPaymentCollected: true
    });

    // Appointment List Modal States
    const [isAppointmentListModalOpen, setIsAppointmentListModalOpen] = useState(false);
    const [appointmentsList, setAppointmentsList] = useState([]);
    const [appointmentDateFilter, setAppointmentDateFilter] = useState('');
    const [appointmentDoctorFilter, setAppointmentDoctorFilter] = useState('');
    const [isLoadingAppointments, setIsLoadingAppointments] = useState(false);

    // Success Modal State
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    function getCurrentDate() {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }

    function getCurrentTime() {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    }

    // Format date to dd/mm/yyyy
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Filter appointments based on date and doctor
    const getFilteredAppointments = () => {
        return appointmentsList.filter(apt => {
            let dateMatch = true;
            if (appointmentDateFilter && apt.AppointmentDate) {
                const aptDate = new Date(apt.AppointmentDate);
                const filterDate = new Date(appointmentDateFilter);
                dateMatch = aptDate.toDateString() === filterDate.toDateString();
            }
            const doctorMatch = !appointmentDoctorFilter || apt.DoctorName === appointmentDoctorFilter;
            return dateMatch && doctorMatch;
        });
    };

    // Toggle Appointment List Modal
    const toggleAppointmentListModal = async () => {
        if (!isAppointmentListModalOpen) {
            setIsLoadingAppointments(true);
            setIsAppointmentListModalOpen(true);
            try {
                const response = await fetchData('AppointmentApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    const sortedAppointments = response.response_data.sort((a, b) => {
                        const dateCompare = new Date(b.AppointmentDate) - new Date(a.AppointmentDate);
                        if (dateCompare !== 0) return dateCompare;
                        return (a.DoctorName || '').localeCompare(b.DoctorName || '');
                    });
                    setAppointmentsList(sortedAppointments);
                } else {
                    setAppointmentsList([]);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                setAppointmentsList([]);
            } finally {
                setIsLoadingAppointments(false);
            }
        } else {
            setIsAppointmentListModalOpen(false);
            setAppointmentDateFilter('');
            setAppointmentDoctorFilter('');
        }
    };

    const toggleModalGroup = () => {
        if (!isModalGrpOpen) {
            fetchPatientsForAppointment();
            fetchDoctorsForAppointment();
            // Find Cash payment mode
            const cashMode = paymentModes.find(mode => mode.Name?.toLowerCase() === 'cash');
            setAppointmentForm({
                patientId: '',
                patientName: '',
                patientMRD: '',
                patientPhone: '',
                doctorId: '',
                appointmentDate: getCurrentDate(),
                appointmentTime: getCurrentTime(),
                consultationamount: '',
                paymentModeId: cashMode?.Id || '',
                remark: '',
                IsPaymentCollected: true
            });
        }
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    const fetchPatientsForAppointment = async () => {
        try {
            const response = await fetchData('PatientApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setPatients(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching patients:', error);
        }
    };

    const fetchDoctorsForAppointment = async () => {
        try {
            const response = await fetchData('DoctorApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDoctors(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching doctors:', error);
        }
    };

    const [paymentModes, setPaymentModes] = useState([]);
    const fetchPaymentModes = async () => {
        try {
            const response = await fetchData('DoctorEntryApi', `/paymentmodes/${companyId}`, token);
            if (response.responseCode === '1111') {
                setPaymentModes(response.response_data);
                // Set default to Cash
                const cashMode = response.response_data.find(mode => mode.Name?.toLowerCase() === 'cash');
                if (cashMode) {
                    setAppointmentForm(prev => ({ ...prev, paymentModeId: cashMode.Id }));
                }
            }
        } catch (error) {
            console.error('Error fetching payment modes:', error);
        }
    };

    const handlePatientSelect = (patient) => {
        setAppointmentForm(prev => ({
            ...prev,
            patientId: patient.Id,
            patientName: patient.Name,
            patientMRD: patient.MRDNo,
            patientPhone: patient.ContactNumber1,
            consultationamount: patient.ConsultationAmount || patient.ConsultationFee || patient.Consultationfee || patient.Amount || patient.Fee
        }));
        setIsPatientModalOpen(false);
    };

    const handleAppointmentChange = (field, value) => {
        if (field === 'doctorId') {
            const selectedDoctor = doctors.find(d => d.Id === parseInt(value) || d.Id === value);
            const consultationFee = selectedDoctor?.ConsultationAmount || selectedDoctor?.ConsultationFee || selectedDoctor?.Consultationfee || selectedDoctor?.Amount || selectedDoctor?.Fee
            setAppointmentForm(prev => ({
                ...prev,
                doctorId: value,
                consultationamount: consultationFee,

            }));
        } else {
            setAppointmentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    // Print appointment bill function
    const printAppointmentBill = (appointmentData, patientData, doctorData) => {
        const formatBillDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        };

        const selectedDoctor = doctors.find(d => d.Id === parseInt(doctorData));
        const selectedPatient = patients.find(p => p.Id === parseInt(patientData));
        const selectedPaymentMode = paymentModes.find(p => p.Id === parseInt(appointmentData.paymentModeId));

        const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Appointment Receipt</title>
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body { font-family: 'Inter', sans-serif; padding: 20px; color: #1f2937; font-size: 13px; background: #f8fafc; }
                    .receipt-container { max-width: 400px; margin: 0 auto; background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); overflow: hidden; }
                    .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 20px; color: white; text-align: center; }
                    .header h1 { font-size: 20px; font-weight: 700; margin-bottom: 4px; }
                    .header p { font-size: 11px; opacity: 0.9; }
                    .receipt-badge { display: inline-block; background: rgba(255,255,255,0.2); padding: 6px 14px; border-radius: 16px; font-size: 11px; font-weight: 600; margin-top: 10px; }
                    .content { padding: 20px; }
                    .section { margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px dashed #e5e7eb; }
                    .section:last-child { border-bottom: none; margin-bottom: 0; }
                    .section-title { font-size: 10px; font-weight: 700; color: #667eea; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 10px; }
                    .info-row { display: flex; justify-content: space-between; margin-bottom: 8px; }
                    .info-row .label { color: #6b7280; font-size: 12px; }
                    .info-row .value { font-weight: 600; color: #1f2937; font-size: 12px; }
                    .patient-name { font-size: 16px; font-weight: 700; color: #1f2937; margin-bottom: 4px; }
                    .mrd-badge { display: inline-block; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 3px 10px; border-radius: 10px; font-size: 10px; font-weight: 600; }
                    .amount-section { background: #f8fafc; padding: 16px; border-radius: 8px; margin-top: 12px; }
                    .total-row { display: flex; justify-content: space-between; align-items: center; }
                    .total-label { font-size: 14px; font-weight: 600; color: #374151; }
                    .total-value { font-size: 22px; font-weight: 700; color: #059669; }
                    .payment-badge { display: inline-block; background: #dcfce7; color: #166534; padding: 4px 12px; border-radius: 12px; font-size: 11px; font-weight: 600; margin-top: 8px; }
                    .footer { text-align: center; padding: 16px; background: #f8fafc; border-top: 1px solid #e5e7eb; font-size: 10px; color: #9ca3af; }
                    @media print {
                        body { padding: 0; background: white; }
                        .receipt-container { box-shadow: none; }
                        .header { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .mrd-badge, .payment-badge { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    }
                </style>
            </head>
            <body>
                <div class="receipt-container">
                    <div class="header">
                        <h1>Appointment Receipt</h1>
                        <p>Consultation Payment</p>
                        <div class="receipt-badge">✓ PAID</div>
                    </div>
                    <div class="content">
                        <div class="section">
                            <div class="section-title">Patient Details</div>
                            <div class="patient-name">${selectedPatient?.Name || appointmentData.patientName || 'N/A'}</div>
                            <div class="mrd-badge">MRD: ${selectedPatient?.MRDNo || appointmentData.patientMRD || 'N/A'}</div>
                            <div style="margin-top: 10px;">
                                <div class="info-row">
                                    <span class="label">Contact</span>
                                    <span class="value">${selectedPatient?.ContactNumber1 || appointmentData.patientPhone || 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section">
                            <div class="section-title">Appointment Details</div>
                            <div class="info-row">
                                <span class="label">Date</span>
                                <span class="value">${formatBillDate(appointmentData.appointmentDate)}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">Time</span>
                                <span class="value">${appointmentData.appointmentTime || 'N/A'}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">Doctor</span>
                                <span class="value">${selectedDoctor?.Name || 'N/A'}</span>
                            </div>
                        </div>
                        <div class="section">
                            <div class="section-title">Payment Details</div>
                            <div class="amount-section">
                                <div class="total-row">
                                    <span class="total-label">Consultation Fee</span>
                                    <span class="total-value">₹${Number(appointmentData.consultationamount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                                </div>
                                <div style="text-align: right; margin-top: 8px;">
                                    <span class="payment-badge">${selectedPaymentMode?.Name || 'Cash'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        Thank you for your visit! • ${new Date().toLocaleString('en-IN')}
                    </div>
                </div>
            </body>
            </html>
        `;

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
            }, 300);
        }
    };

    // Print appointment from table row data - A4 Size Compact
    const printAppointmentFromTable = (item) => {
        const formatBillDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        };

        const formatTime = (timeString) => {
            if (!timeString) return 'N/A';
            return timeString;
        };

        const printContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Receipt - ${item.PatientName || 'Patient'}</title>
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    @page { size: A4 portrait; margin: 10mm; }
                    body { font-family: 'Inter', sans-serif; color: #1f2937; font-size: 11px; background: #f8fafc; line-height: 1.4; }
                    .page-container { width: 210mm; min-height: 297mm; margin: 0 auto; background: white; box-shadow: 0 2px 10px rgba(0,0,0,0.1); position: relative; }
                    
                    /* Header - Compact */
                    .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 12px 20px; color: white; display: flex; justify-content: space-between; align-items: center; }
                    .company-info h1 { font-size: 16px; font-weight: 700; margin-bottom: 2px; }
                    .company-info p { font-size: 9px; opacity: 0.9; }
                    .receipt-badge { background: rgba(255,255,255,0.2); padding: 5px 12px; border-radius: 12px; font-size: 9px; font-weight: 600; }
                    
                    /* Content - Compact */
                    .content { padding: 15px 20px; }
                    .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px; }
                    .info-card { background: #fafbfc; border-radius: 6px; padding: 10px 12px; border: 1px solid #e5e7eb; }
                    .section-title { font-size: 8px; font-weight: 700; color: #667eea; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; padding-bottom: 4px; border-bottom: 1px solid #667eea; display: inline-block; }
                    .patient-name { font-size: 14px; font-weight: 700; color: #1f2937; margin-bottom: 4px; }
                    .mrd-badge { display: inline-block; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 2px 8px; border-radius: 8px; font-size: 8px; font-weight: 600; margin-bottom: 8px; }
                    .info-row { display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #f1f5f9; }
                    .info-row:last-child { border-bottom: none; }
                    .info-row .label { color: #6b7280; font-size: 9px; }
                    .info-row .value { font-weight: 600; color: #1f2937; font-size: 10px; }
                    
                    /* Payment - Compact */
                    .payment-section { background: ${item.IsPaymentCollected ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' : 'linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)'}; border-radius: 8px; padding: 12px 15px; margin-top: 10px; border: 1px solid ${item.IsPaymentCollected ? '#86efac' : '#fca5a5'}; }
                    .payment-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
                    .payment-title { font-size: 8px; font-weight: 700; color: ${item.IsPaymentCollected ? '#166534' : '#dc2626'}; text-transform: uppercase; letter-spacing: 1px; }
                    .payment-badge { background: ${item.IsPaymentCollected ? '#166534' : '#dc2626'}; color: white; padding: 3px 10px; border-radius: 10px; font-size: 8px; font-weight: 600; }
                    .amount-display { text-align: center; padding: 8px 0; }
                    .amount-label { font-size: 9px; color: #166534; margin-bottom: 4px; }
                    .amount-value { font-size: 28px; font-weight: 700; color: #059669; }
                    
                    
                    /* Footer - Compact */
                    .footer { text-align: center; padding: 12px 20px; background: #f8fafc; border-top: 1px solid #e5e7eb; font-size: 9px; color: #9ca3af; margin-top: 20px; }
                    
                    @media print {
                        body { background: white; padding: 0; }
                        .page-container { box-shadow: none; width: 100%; min-height: auto; }
                        .header, .mrd-badge, .payment-badge, .payment-section { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    }
                    @media screen and (max-width: 800px) {
                        .page-container { width: 100%; min-height: auto; }
                        .header { flex-direction: column; text-align: center; gap: 8px; padding: 10px; }
                        .content { padding: 10px; }
                        .info-grid { grid-template-columns: 1fr; gap: 10px; }
                    }
                </style>
            </head>
            <body>
                <div class="page-container">
                    <div class="header">
                        <div class="company-info">
                            <h1>${formData?.Name || 'Clinic'}</h1>
                            <p>${formData?.AddressLine1 || ''}${formData?.AddressLine2 ? ', ' + formData.AddressLine2 : ''}${formData?.Location ? ', ' + formData.Location : ''}${formData?.PostalCode ? ' - ' + formData.PostalCode : ''}</p>
                            <p>${formData?.ContactNumber1 ? '📞 ' + formData.ContactNumber1 : ''}${formData?.Email ? ' • ✉️ ' + formData.Email : ''}${formData?.GSTNumber ? ' • GST: ' + formData.GSTNumber : ''}</p>
                        </div>
                        <div class="receipt-badge">${item.IsPaymentCollected ? '✓ PAID' : '⏳ PENDING'}</div>
                    </div>
                    <div class="content">
                     <div class="section-title">Consultation Receipt Bill</div>
                        <div class="info-grid">
                            <div class="info-card">
                                <div class="section-title">Patient</div>
                                <div class="patient-name">${item.PatientName || 'N/A'}</div>
                                <div class="mrd-badge">MRD: ${item.MRDNo || 'N/A'}</div>
                                <div class="info-row">
                                    <span class="label">Contact</span>
                                    <span class="value">${item.ContactNumber1 || 'N/A'}</span>
                                </div>
                                <div class="info-row">
                                    <span class="label">Address</span>
                                    <span class="value">${item.PatientAddress || 'N/A'}</span>
                                </div>
                            </div>
                            <div class="info-card">
                                <div class="section-title">Appointment</div>
                                <div class="info-row">
                                    <span class="label">Date</span>
                                    <span class="value">${formatBillDate(item.AppointmentDate)}</span>
                                </div>
                                <div class="info-row">
                                    <span class="label">Time</span>
                                    <span class="value">${formatTime(item.AppointmentTime)}</span>
                                </div>
                                 <div class="info-row">
                                    <span class="label">Token No</span>
                                    <span class="value">${(item.AppointmentNo)}</span>
                                </div>
                                <div class="info-row">
                                    <span class="label">Doctor</span>
                                    <span class="value">${item.DoctorName || 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                        <div class="payment-section">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <div class="payment-header" style="margin-bottom: 8px;">
                                        <span class="payment-title">${item.IsPaymentCollected ? 'Payment ₹' + Number(item.Amount || item.BillAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 }) + ' Received' : 'Amount Not Received'}</span>
                                    </div>
                                    <span class="payment-badge">${item.IsPaymentCollected ? (item.PaymentTypeName || 'Cash') : 'PENDING'}</span>
                                    <div style="margin-top: 8px; font-size: 12px; font-weight: 700; color: ${item.IsPaymentCollected ? '#059669' : '#dc2626'};">₹${Number(item.Amount || item.BillAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                                </div>
                                ${formData?.PaymentUPIId ? `
                                <div style="text-align: center;">
                                    <img src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent('upi://pay?pa=' + formData.PaymentUPIId + '&pn=' + encodeURIComponent(formData.PaymentUPIName || formData.Name || 'Clinic') + '&am=' + Number(item.Amount || item.BillAmount || 0) + '&cu=INR')}" alt="UPI QR Code" style="width: 80px; height: 80px;" />
                                    <div style="font-size: 8px; color: #6b7280; margin-top: 4px;">Scan to Pay</div>
                                </div>
                                ` : ''}
                            </div>
                        </div>
                        <div style="margin-top: 30px; padding-top: 20px; border-top: 1px dashed #e5e7eb; text-align: right; padding-right: 20px;">
                            <div style="display: inline-block; text-align: center; min-width: 200px;">
                                <div style="border-bottom: 2px solid #1f2937; height: 45px; margin-bottom: 8px;"></div>
                                <p style="font-size: 12px; color: #1f2937; font-weight: bold; margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact;">Authorized Signature</p>
                            </div>
                        </div>
                    </div>
                    <div class="footer">Thank you for choosing ${companyDetails?.Name || 'us'}! • ${new Date().toLocaleString('en-IN')}</div>
                </div>
            </body>
            </html>
        `;

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
            }, 300);
        }
    };

    const handleAppointmentSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const payload = {
                ...appointmentForm,
                CompanyId: companyId,
                PatientId: appointmentForm.patientId,
                DoctorId: appointmentForm.doctorId,
                AppointmentDate: appointmentForm.appointmentDate,
                AppointmentTime: appointmentForm.appointmentTime,
                Amount: Number(appointmentForm.consultationamount),
                BillAmount: Number(appointmentForm.consultationamount),
                ReceivedAmount: appointmentForm.IsPaymentCollected ? Number(appointmentForm.consultationamount) : 0,
                PaymentTypeId: parseInt(appointmentForm.paymentModeId) || null,
                Remark: appointmentForm.remark || '',
                IsPaymentCollected: appointmentForm.IsPaymentCollected || false,
                CreatedBy: userId,
                CreatedDate: new Date(),
                AppointmentNumber: ''
            };

            const response = await postData('AppointmentApi', payload, token);
            console.log('Appointment Created response:', response);

            // If payment is collected, print the bill automatically
            if (appointmentForm.IsPaymentCollected) {
                printAppointmentBill(appointmentForm, appointmentForm.patientId, appointmentForm.doctorId);
            }

            // Show success modal for any successful response
            setIsModalGrpOpen(false);
            setIsLoading(false);
            setShowSuccessModal(true);
            // Auto close success modal and refresh after 2 seconds
            setTimeout(() => {
                setShowSuccessModal(false);
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.error('Error creating appointment:', error);
            setIsLoading(false);
            alert('Failed to create appointment');
        }
    };

    const filteredPatients = patients.filter(patient =>
        patient.Name?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
        patient.MRDNo?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
        patient.ContactNumber1?.includes(patientSearchQuery)
    );

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between' style={{ marginTop: '-20px' }}>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', textTransform: 'uppercase' }}>Appointment</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% { box-shadow: .2em 0px 0 0px currentcolor; }
                                12% { box-shadow: .2em .2em 0 0 currentcolor; }
                                25% { box-shadow: 0 .2em 0 0px currentcolor; }
                                37% { box-shadow: -.2em .2em 0 0 currentcolor; }
                                50% { box-shadow: -.2em 0 0 0 currentcolor; }
                                62% { box-shadow: -.2em -.2em 0 0 currentcolor; }
                                75% { box-shadow: 0px -.2em 0 0 currentcolor; }
                                87% { box-shadow: .2em -.2em 0 0 currentcolor; }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>

                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>From Date</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            style={{
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                padding: '0 10px',
                                fontSize: '12px',
                                outline: 'none',
                                width: '140px'
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <label style={{ fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>To Date</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            style={{
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                padding: '0 10px',
                                fontSize: '12px',
                                outline: 'none',
                                width: '140px'
                            }}
                        />
                    </div>

                </div>

                <Tooltip
                    title="View All Appointments" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#059669',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleAppointmentListModal}
                        className="linkcolor"
                    >
                        📋 All Appointments
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Create New Appointment" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroup}
                        className="linkcolor"
                    >
                        New Appointment
                    </Button>
                </Tooltip>

            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>
                            <TableRow>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Sl.No
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Appointment No
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    MRD No
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Name & Contact
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Charted By
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Status
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', width: '5%' }}>{item.AppointmentNo}</TableCell>
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', width: '5%' }}>{item.MRDNo}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', width: '50%' }}>{item.PatientName} / {item.ContactNumber1}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.DoctorName}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'center', borderRight: '1px solid #f4dfdfff', fontSize: '10px' }}>
                                        <span style={{
                                            padding: '3px 8px',
                                            borderRadius: '12px',
                                            fontWeight: '600',
                                            background: item.IsPaymentCollected ? '#dcfce7' : '#fef2f2',
                                            color: item.IsPaymentCollected ? '#166534' : '#dc2626',
                                            border: item.IsPaymentCollected ? '1px solid #86efac' : '1px solid #fca5a5'
                                        }}>
                                            {item.IsPaymentCollected ? '✓ Paid' : '⏳ Pending'}
                                        </span>
                                    </TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
                                        {!item.IsCompleted && (
                                            <Tooltip
                                                title="Doctor Entry" arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#10b981',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                }}
                                            >
                                                <IconButton onClick={() => history.push(`/DoctorEntryCreateIds/${item.Id}`)}>
                                                    <MedicalServicesIcon style={{ color: '#10b981', fontSize: '17px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {!item.IsCompleted && (
                                            <Tooltip
                                                title="Appointment Delete" arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#DA6C6C',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                }}
                                            >
                                                <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                    {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {/* Print Button - Show for all appointments */}
                                        <Tooltip
                                            title="Print Receipt" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#1d4ed8',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => printAppointmentFromTable(item)}>
                                                <span style={{ fontSize: '15px' }}>🖨️</span>
                                            </IconButton>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                        Cancel
                    </button>
                    <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                        Confirm
                    </button>
                </DialogActions>
            </Dialog>

            {/* Footer */}
            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>

            {/* Success Modal */}
            {showSuccessModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10001,
                    animation: 'fadeIn 0.3s ease-out'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '40px 50px',
                        textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                        animation: 'scaleIn 0.4s ease-out'
                    }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            animation: 'bounceIn 0.5s ease-out 0.2s both'
                        }}>
                            <CheckCircleIcon style={{ fontSize: '50px', color: 'white' }} />
                        </div>
                        <h2 style={{
                            color: '#059669',
                            fontSize: '24px',
                            fontWeight: '700',
                            margin: '0 0 10px 0'
                        }}>
                            Success!
                        </h2>
                        <p style={{
                            color: '#6b7280',
                            fontSize: '16px',
                            margin: 0
                        }}>
                            Appointment created successfully
                        </p>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes scaleIn {
                    from { opacity: 0; transform: scale(0.8); }
                    to { opacity: 1; transform: scale(1); }
                }
                @keyframes bounceIn {
                    0% { transform: scale(0); }
                    50% { transform: scale(1.2); }
                    100% { transform: scale(1); }
                }
            `}</style>

            {/* Appointment Creation Modal */}
            {isModalGrpOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '16px',
                        width: '90%',
                        maxWidth: '900px',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            padding: '20px',
                            color: 'white',
                            height: '60px',
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: '700' }}>Create New Appointment</h5>
                                <button
                                    onClick={toggleModalGroup}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        color: 'white',
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </div>

                        {/* Modal Body */}
                        <div style={{ padding: '20px', maxHeight: 'calc(85vh - 150px)', overflowY: 'auto' }}>
                            <form onSubmit={handleAppointmentSubmit}>
                                {/* Form Grid - Row 1 */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                    {/* Doctor */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Doctor <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <select
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '11px', outline: 'none', backgroundColor: 'white', height: '32px' }}
                                            value={appointmentForm.doctorId || ''}
                                            onChange={(e) => handleAppointmentChange("doctorId", e.target.value)}
                                        >
                                            <option value="">Select Doctor</option>
                                            {doctors.map((doctor) => (
                                                <option key={doctor.Id} value={doctor.Id}>{doctor.Name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* Patient Name */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Patient Name <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            readOnly
                                            placeholder="Click to select patient"
                                            onClick={() => setIsPatientModalOpen(true)}
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', backgroundColor: '#f9fafb', height: '32px', cursor: 'pointer' }}
                                            value={appointmentForm.patientName || ''}
                                        />
                                    </div>
                                    {/* MRD No */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>MRD No</label>
                                        <input
                                            type="text"
                                            readOnly
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', backgroundColor: '#f9fafb', height: '32px' }}
                                            value={appointmentForm.patientMRD || ''}
                                        />
                                    </div>
                                    {/* Phone No */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>Phone No</label>
                                        <input
                                            type="text"
                                            readOnly
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', backgroundColor: '#f9fafb', height: '32px' }}
                                            value={appointmentForm.patientPhone || ''}
                                        />
                                    </div>
                                </div>

                                {/* Form Grid - Row 2 */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 100px 1.5fr', gap: '16px', marginBottom: '16px' }}>
                                    {/* Appointment Date */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Appointment Date <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', outline: 'none', height: '32px' }}
                                            value={appointmentForm.appointmentDate || ''}
                                            onChange={(e) => handleAppointmentChange("appointmentDate", e.target.value)}
                                        />
                                    </div>
                                    {/* Appointment Time */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Appointment Time <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="time"
                                            style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', outline: 'none', height: '32px' }}
                                            value={appointmentForm.appointmentTime || ''}
                                            onChange={(e) => handleAppointmentChange("appointmentTime", e.target.value)}
                                        />
                                    </div>
                                    {/* Amount */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Amount <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="number"
                                            style={{ width: '100%', padding: '8px 10px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', outline: 'none', textAlign: 'right', height: '32px' }}
                                            value={appointmentForm.consultationamount || ''}
                                            onChange={(e) => handleAppointmentChange("consultationamount", e.target.value)}
                                        />
                                    </div>
                                    {/* Payment Modes */}
                                    <div>
                                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>
                                            Payment Modes <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                            <select
                                                style={{ width: '100px', padding: '4px 8px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '11px', outline: 'none', backgroundColor: 'white', height: '32px' }}
                                                value={appointmentForm.paymentModeId || ''}
                                                onChange={(e) => handleAppointmentChange("paymentModeId", e.target.value)}
                                            >
                                                <option value="">Select</option>
                                                {paymentModes.map((Modes) => (
                                                    <option key={Modes.Id} value={Modes.Id}>{Modes.Name}</option>
                                                ))}
                                            </select>
                                            {/* Payment Received Checkbox */}
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', fontSize: '10px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={appointmentForm.IsPaymentCollected || false}
                                                    onChange={(e) => handleAppointmentChange("IsPaymentCollected", e.target.checked)}
                                                    style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#1e40af' }}
                                                />
                                                Payment Received
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Remark */}
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px', fontWeight: '600', color: '#374151', textTransform: 'uppercase' }}>Remark</label>
                                    <textarea
                                        style={{ width: '100%', padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', minHeight: '25px', resize: 'vertical', outline: 'none' }}
                                        rows={1}
                                        value={appointmentForm.remark || ''}
                                        onChange={(e) => handleAppointmentChange("remark", e.target.value)}
                                    ></textarea>
                                </div>

                                {/* Submit Buttons */}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={() => setIsModalGrpOpen(false)}
                                        disabled={isLoading}
                                        style={{ padding: '10px 24px', background: 'white', border: '2px solid #e5e7eb', borderRadius: '8px', height: '29px', fontSize: '13px', fontWeight: '600', color: '#6b7280', cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1, display: 'flex', alignItems: 'center' }}
                                    >
                                        <span>Cancel</span>
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        style={{ padding: '10px 24px', background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)', border: 'none', borderRadius: '8px', height: '29px', fontSize: '13px', fontWeight: '600', color: 'white', cursor: isLoading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '8px', opacity: isLoading ? 0.7 : 1 }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <CircularProgress size={18} color="inherit" />
                                                <span>Saving...</span>
                                            </>
                                        ) : (
                                            <>
                                                <span>💾</span>
                                                <span>Save Appointment</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Patient Selection Modal */}
            {isPatientModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '80vh',
                        overflow: 'hidden',
                        boxShadow: '0 25px 80px rgba(0, 0, 0, 0.4)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #5ccfe3ff 0%, #6e15c7ff 100%)',
                            padding: '20px 24px',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            height: '50px',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <span style={{ fontSize: '14px' }}>👤</span>
                                <div>
                                    <h6 style={{ margin: 0, textTransform: 'uppercase', fontWeight: '700' }}>Select Patient</h6>
                                </div>
                            </div>
                            <button
                                onClick={() => setIsPatientModalOpen(false)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    color: 'white',
                                    fontSize: '22px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Search */}
                        <div style={{ padding: '20px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    placeholder="Search by name, MRD, or phone..."
                                    value={patientSearchQuery}
                                    onChange={(e) => setPatientSearchQuery(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px 12px 44px',
                                        border: '2px solid #e2e8f0',
                                        borderRadius: '12px',
                                        fontSize: '14px',
                                        outline: 'none',
                                        transition: 'all 0.2s',
                                        background: 'white',
                                        height: '30px',
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                                />
                            </div>
                            <div style={{ marginTop: '2px', fontSize: '12px', color: '#64748b' }}>
                                {filteredPatients.length} patient(s) found
                            </div>
                        </div>

                        {/* Patient List */}
                        <div style={{ maxHeight: 'calc(80vh - 200px)', overflowY: 'auto', padding: '16px 24px', marginTop: '-10px' }}>
                            {filteredPatients.length > 0 ? (
                                filteredPatients.map((patient, index) => (
                                    <div
                                        key={patient.Id}
                                        onClick={() => handlePatientSelect(patient)}
                                        style={{
                                            padding: '3px',
                                            border: '2px solid #e2e8f0',
                                            borderRadius: '12px',
                                            marginBottom: '12px',
                                            cursor: 'pointer',
                                            transition: 'all 0.25s ease',
                                            background: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#667eea';
                                            e.currentTarget.style.background = 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)';
                                            e.currentTarget.style.transform = 'translateX(4px)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                            e.currentTarget.style.background = 'white';
                                            e.currentTarget.style.transform = 'translateX(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    >
                                        {/* Avatar */}
                                        <div style={{
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '12px',
                                            background: 'linear-gradient(135deg, #66e1eaff 0%, #764ba2 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '18px',
                                            fontWeight: '700',
                                            flexShrink: 0
                                        }}>
                                            {patient.Name?.charAt(0)?.toUpperCase() || '?'}
                                        </div>
                                        {/* Patient Info */}
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontWeight: '700', fontSize: '15px', color: '#1e293b', marginBottom: '4px' }}>
                                                {patient.Name}
                                            </div>
                                            <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#64748b' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ color: '#667eea', fontWeight: '600' }}>MRD:</span> {patient.MRDNo || 'N/A'}
                                                </span>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ color: '#667eea', fontWeight: '600' }}>📞</span> {patient.ContactNumber1 || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        {/* Arrow */}
                                        <div style={{ color: '#94a3b8', fontSize: '20px' }}>→</div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                                    <span style={{ fontSize: '48px', display: 'block', marginBottom: '16px' }}>🔍</span>
                                    <p style={{ color: '#64748b', fontSize: '16px', fontWeight: '600', margin: '0 0 8px 0' }}>No patients found</p>
                                    <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>Try a different search term</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Appointment List Modal */}
            {isAppointmentListModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '1200px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            height: '55px',
                        }}>
                            <div>
                                <h6 style={{ color: 'white', fontWeight: '700', margin: 0 }}>
                                    📋 All Appointments
                                </h6>
                                <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '13px', margin: '4px 0 0 0' }}>
                                    Showing all patient appointments
                                </p>
                            </div>
                            <button
                                onClick={toggleAppointmentListModal}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: 'white',
                                    fontSize: '22px',
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Filter Bar */}
                        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', background: '#f9fafb', display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    📅 Filter by Date
                                </label>
                                <input
                                    type="date"
                                    value={appointmentDateFilter}
                                    onChange={(e) => setAppointmentDateFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                    }}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    👨‍⚕️ Filter by Doctor
                                </label>
                                <select
                                    value={appointmentDoctorFilter}
                                    onChange={(e) => setAppointmentDoctorFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        backgroundColor: 'white',
                                    }}
                                >
                                    <option value="">All Doctors</option>
                                    {[...new Set(appointmentsList.map(apt => apt.DoctorName).filter(Boolean))].sort().map((doctorName, index) => (
                                        <option key={index} value={doctorName}>{doctorName}</option>
                                    ))}
                                </select>
                            </div>
                            {(appointmentDateFilter || appointmentDoctorFilter) && (
                                <button
                                    onClick={() => {
                                        setAppointmentDateFilter('');
                                        setAppointmentDoctorFilter('');
                                    }}
                                    style={{
                                        padding: '8px 16px',
                                        background: '#ef4444',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        marginTop: '20px',
                                    }}
                                >
                                    ✕ Clear
                                </button>
                            )}
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 160px)', padding: '0' }}>
                            {isLoadingAppointments ? (
                                <div style={{ padding: '40px', textAlign: 'center' }}>
                                    <CircularProgress size={40} style={{ color: '#059669' }} />
                                    <p style={{ marginTop: '16px', color: '#6b7280' }}>Loading appointments...</p>
                                </div>
                            ) : getFilteredAppointments().length === 0 ? (
                                <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                                    <p style={{ fontSize: '16px', fontWeight: '500' }}>
                                        {(appointmentDateFilter || appointmentDoctorFilter) ? 'No appointments match your filters' : 'No appointments found'}
                                    </p>
                                </div>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            {['#', 'Date', 'Time', 'Patient Name', 'MRD No', 'Doctor', 'Amount', 'Status'].map((header, idx) => (
                                                <th key={idx} style={{
                                                    background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                    color: 'white',
                                                    padding: '10px',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    textAlign: header === 'Amount' ? 'right' : 'left',
                                                    textTransform: 'uppercase',
                                                    borderRight: '1px solid rgba(255,255,255,0.1)'
                                                }}>
                                                    {header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getFilteredAppointments().map((appointment, index) => (
                                            <tr
                                                key={appointment.Id}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb',
                                                    transition: 'background-color 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#f9fafb'}
                                            >
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#059669', fontWeight: '600', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {formatDate(appointment.AppointmentDate)}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.AppointmentTime || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.PatientName || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.MRDNo || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.DoctorName || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.Amount || '0'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '11px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.IsCompleted ? (
                                                        <span style={{ background: '#d1fae5', color: '#065f46', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ✓ Completed
                                                        </span>
                                                    ) : appointment.IsRescheduled ? (
                                                        <span style={{ background: '#fef3c7', color: '#92400e', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ↻ Rescheduled
                                                        </span>
                                                    ) : (
                                                        <span style={{ background: '#dbeafe', color: '#1e40af', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ⏳ Pending
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AppointmentIndex; 